import { render, staticRenderFns } from "./ShortSection.vue?vue&type=template&id=a052bde6&scoped=true&"
import script from "./ShortSection.vue?vue&type=script&lang=js&"
export * from "./ShortSection.vue?vue&type=script&lang=js&"
import style0 from "./ShortSection.vue?vue&type=style&index=0&id=a052bde6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a052bde6",
  null
  
)

export default component.exports